import React, { useContext } from "react";
import { Box } from "../styles";
import bgImage from "assets/images/bg.jpeg";
import Button from "components/Button";
import AuthViewModel from "../viewModel";
import SpinnerLoading from "components/SpinnerLoading";
import { Container, Card, Button as BootstrapButton } from 'react-bootstrap';

function Login() {
	const { isLoading, onLogin } = useContext(AuthViewModel.Context);

	const onLoginButtonClick = () => {
		window.location.href = 'https://fm-portal-prod.hld-thehenderson.igcexpertcloud.com/login';
	}

	return (
		<div style={{ backgroundImage: `url(${bgImage})`, width: '100%', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
			<Box>
				{isLoading && <SpinnerLoading />}
				<Container fluid>
					<div className="bg-dark w-100 px-5 py-2 position-fixed top-0 start-0 d-flex align-items-center justify-content-between">
						<Button
							variant="primary"
							size="lg"
							onClick={onLogin}
							className="w-100"
							style={{ color: '#fff' }}
						>
							Admin Portal - Login
						</Button>
						<Button
							variant="primary"
							size="lg"
							onClick={onLogin}
							className="w-100"
							style={{ color: '#fff' }}
						>
							User Management
						</Button>
					</div>
					<Card className="text-center shadow-lg p-3 mb-5 bg-white rounded" style={{ maxWidth: '400px' }}>
						<Card.Body>
							<Card.Title className="mb-4">Welcome to The Henderson</Card.Title>
							<Card.Text className="mb-4">
								Sign in with your corporate account to continue.
							</Card.Text>
							<BootstrapButton
								variant="dark"
								size="lg"
								onClick={onLoginButtonClick}
								className="w-100"
							>
								{/* Sign in with SSO */}
								Login
							</BootstrapButton>
							<BootstrapButton variant="link" style={{ textAlign: "right", color: '#212529' }} onClick={() => window.location.href = 'https://passwordreset.microsoftonline.com/'}>
								Forgot Password?
							</BootstrapButton>
						</Card.Body>
					</Card>
				</Container>
			</Box>
		</div>
	)
}

export default AuthViewModel.withProvider(Login);
